var map = {
	"./cooldown.svg": 46434,
	"./error.svg": 72729,
	"./freespins.svg": 27982,
	"./info.svg": 98933,
	"./loader/01high.svg": 36950,
	"./loader/bug.svg": 39303,
	"./loader/flame.svg": 68888,
	"./loader/low.svg": 43187,
	"./loader/medium.svg": 67114,
	"./loader/rocket.svg": 71031,
	"./loader/signal.svg": 3099,
	"./loader/zap.svg": 13060,
	"./ok.svg": 27015,
	"./question.svg": 94965,
	"./warning.svg": 38383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54613;